<div class="page-container" *ngIf="selectedVessel">
  <div class="vessel-title-container">
    <ng-container *ngIf="isPendingApproval">
      <div class="remove-request-button-container">
        <div
          class="remove-request-button"
          data-cy="vessel-folder-widthraw-request-button"
          (click)="withdrawApprovalRequest()"
          *ngIf="canWithdrawApproval()">
          {{ 'vessel.page.request-approval.remove' | translate }}
        </div>
      </div>
    </ng-container>
    <div class="row-container">
      <div class="column-container">
        <div class="column-title" data-cy="vessel-folder-vessel-number-label">
          {{ 'vessel.page.number.title' | translate }}
        </div>
        <div class="column-text">
          <div class="vessel-number-text" data-cy="vessel-folder-vessel-number">
            {{ selectedVessel.number }}
          </div>
          <mat-icon
            svgIcon="arrow-down"
            class="arrow-icon"
            data-cy="vessel-folder-more-options-button"
            (click)="showOtherOptions = !showOtherOptions; $event.stopPropagation()"
            [ngStyle]="{
              transform: showOtherOptions ? 'rotate(180deg)' : '',
            }" />
          <div *ngIf="showOtherOptions" style="position: relative; align-self: end">
            <div class="more-options-container" #otherOptions>
              <div
                class="extra-option"
                data-cy="vessel-folder-more-options-edit-button"
                (click)="editVessel()"
                [class.disabledOption]="!editVesselIsEnabled()">
                <mat-icon
                  svgIcon="edit-pen"
                  class="icon"
                  data-cy="vessel-folder-more-options-edit-button-icon" />
                {{ 'vessel.page.button.edit.vessel' | translate }}
              </div>
              <div
                class="extra-option"
                data-cy="vessel-folder-more-options-delete-button"
                (click)="deleteVessel()"
                [class.disabledOption]="!deleteVesselIsEnabled()">
                <mat-icon
                  svgIcon="delete"
                  class="icon"
                  data-cy="vessel-folder-more-options-delete-button-icon" />
                {{ 'vessel.page.button.delete.vessel' | translate }}
              </div>
              <div
                class="extra-option"
                data-cy="vessel-folder-more-options-duplicate-button"
                (click)="duplicateVessel()">
                <mat-icon
                  svgIcon="duplicate"
                  class="icon"
                  data-cy="vessel-folder-more-options-duplicate-button-icon" />
                {{ 'vessel.page.button.duplicate.vessel' | translate }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="left-row-container">
        <div class="column-container">
          <div class="column-title" data-cy="vessel-folder-vessel-name-label">
            {{ 'vessel.page.name.title' | translate }}
          </div>
          <div class="column-text" data-cy="vessel-folder-vessel-name">
            {{ selectedVessel.name }}
          </div>
        </div>
        <div class="status-container">
          <div class="column-container small-container">
            <div class="column-title" data-cy="vessel-folder-version-status-label">
              {{ 'vessel.page.status.title' | translate }}
            </div>
            <div class="column-text" data-cy="vessel-folder-version-status">
              {{ vesselStatus | translate }}
            </div>
          </div>
          <mat-icon
            [svgIcon]="projectIcon"
            class="header-icon"
            data-cy="vessel-folder-version-status-icon"
            [class.iconBackground]="hasIconBackground" />
        </div>
      </div>
    </div>
  </div>
  <app-vessel-project-buttons
    style="container-type: inline-size; position: relative; z-index: 10"
    *ngIf="selectedVessel.projectVersion"
    [buttonsAreDisabled]="shouldBlurPage"
    [hasPreviousVersion]="hasPreviousVersion"
    [shipyardiApi]="shipyardiApi"
    [vessel]="selectedVessel"></app-vessel-project-buttons>

  <app-request-approval-message
    [versionToApprove]="versionToApprove"
    [shipyardiApi]="shipyardiApi"
    [vessel]="selectedVessel"
    (onProjectStatusChanged)="handleProjectStatusChanged($event)"></app-request-approval-message>
  <app-request-access-message
    [vessel]="selectedVessel"
    (onBlurPage)="shouldBlurPage = true"></app-request-access-message>
  <app-ownership-transfer-message
    [vessel]="selectedVessel"
    [editors]="vesselsEditors"
    [approversList]="approversList"
    [ownershipTransfers]="ownershipTransfers"
    (onUpdateRequest)="handleTransferUpdate($event)"></app-ownership-transfer-message>
  <app-guest-left-message [vessel]="selectedVessel"></app-guest-left-message>
  <div>
    <app-vessel-info-container
      #VesselInfo
      [(selectedVessel)]="selectedVessel"
      [accessRequestId]="accessRequestId"
      [shipyardiApi]="shipyardiApi"
      [approversList]="approversList"
      [hasPreviousVersion]="hasPreviousVersion"
      [ownershipTransfers]="ownershipTransfers"
      [shipyardList]="shipyardList"
      (onEditorLeave)="handleEditorLeave($event)"
      (onOwnerChange)="handleOwnerChange($event)"
      (onEditorsFound)="vesselsEditors = $event"></app-vessel-info-container>
  </div>

  <div class="vessel-page-section">
    <div class="page-section-title">
      {{ 'vessel.page.overview.title' | translate }}
    </div>
    <div class="vessel-stats" [ngClass]="{ blur: shouldBlurPage }">
      <div class="gradient-container">
        <div class="stats">
          <mat-icon
            svgIcon="ops-screen"
            class="vessel-stats-icon"
            data-cy="vessel-folder-ops-number-icon" />
          <div class="stats-number">
            <div class="stats-number-value" data-cy="vessel-folder-ops-number">
              {{ selectedVessel.numberOps }}
            </div>
            <div class="stats-label" data-cy="vessel-folder-ops-number-label">
              {{ 'vessel.page.overview.OPS' | translate }}
            </div>
          </div>
        </div>
      </div>
      <div class="gradient-container">
        <div class="stats">
          <mat-icon
            svgIcon="fcu"
            class="vessel-stats-icon"
            data-cy="vessel-folder-fcu-number-icon" />
          <div class="stats-number">
            <div class="stats-number-value" data-cy="vessel-folder-fcu-number">
              {{ selectedVessel.numberFcu }}
            </div>
            <div class="stats-label" data-cy="vessel-folder-fcu-number-label">
              {{ 'vessel.page.overview.FCU' | translate }}
            </div>
          </div>
        </div>
      </div>

      <div class="gradient-container">
        <div class="stats">
          <mat-icon svgIcon="excel-channels" class="vessel-stats-icon" />
          <div class="stats-number">
            <div class="stats-number-value">
              {{ selectedVessel.numberOfChannels }}
            </div>
            <div class="stats-label">
              {{ 'vessel.page.overview.channels' | translate }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <app-vessel-mimics-preview
    [ngClass]="{ blur: shouldBlurPage }"
    *ngIf="selectedVessel.projectVersion"
    [vessel]="selectedVessel"></app-vessel-mimics-preview>

  <ng-container *ngIf="isLoading">
    <app-loading-spinner class="spinner-loading"></app-loading-spinner
  ></ng-container>
</div>

<app-confirmation-window
  #removeRequestConfirmation
  [mainLabel]="'vessel.page.remove-request.title'"
  [subLabel]="'vessel.page.remove-request.subLabel'"
  [discardLabel]="'vessel.page.remove-request.discardLabel'"
  [saveLabel]="'vessel.page.remove-request.continue'"
  [allButtonsLeft]="true"
  [inverseColors]="true">
</app-confirmation-window>
